module.exports = __webpack_public_path__ + "static/azul-93f5bb8e8e644de4149065fba45e1711.png";